import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import AuthContext from "../context";
import { MainApi } from "../../../services/authentication/api";
import { Configuration } from "../../../services/authentication/configuration";
import { set } from "lodash";
import SmsVerificationResetPassword from "./components/SmsVerification/SmsVerification";
import NewPassword from "./components/newPassword/NewPassword";
import { use } from "i18next";


export default function ResetPassword() {
    const mainApi = new MainApi(new Configuration({ basePath: process.env.REACT_APP_AUTHENTICATION_API_BASE_PATH }));
    const toast = useRef(null);
    const contextVal = useContext(AuthContext);
    const [verificationCode, setVerificationCode] = useState("");
    const [userMail, setUserMail] = useState("");
    const [emailSmsSendView, setEmailSmsSendView] = useState(true);
    const [smsVerificationView, setSmsVerificationView] = useState(false);
    const [newPasswordView, setNewPasswordView] = useState(false);
    const [fingerPrint, setfFingerPrint] = useState("");

    useEffect(() => {
        if (fingerPrint !== "") {
            
            setTimeout(() => {
                setNewPasswordView(true);
                setSmsVerificationView(false);
            }, 500);

        }
    }, [fingerPrint]);


    const clickResetPassword = () => {

        try {

            if (userMail === "") {
                toast.current.show({
                    severity: "error",
                    summary: "Hata",
                    detail: "E-Posta Adresi Boş Olamaz.",
                    life: 3000,
                });
                return;
            }

            if (!validateEmail(userMail)) {
                toast.current.show({
                    severity: "error",
                    summary: "Hata",
                    detail: "Geçerli Bir E Posta Adresi Giriniz.",
                    life: 3000,
                });
                return;
            }

            toast.current.show({
                severity: "info",
                summary: "Bilgi",
                detail: "SMS Gönderiliyor... Lütfen Bekleyiniz.",
                life: 3000,
            });


            // setEmailSmsSendView(false);
            // setSmsVerificationView(true);

            

            mainApi.apiMainSendResetPasswordSmsGet(userMail).then((response) => {
                
                console.log("clickResetPassword: " + response);

                if (response.data.Status == 'Ok') {
                    toast.current.show({
                        severity: "success",
                        summary: "Şifre Sıfırlama SMS'i Gönderildi.",
                        detail: "Lütfen SMS'inizi Kontrol Ediniz.",
                        life: 3000,
                    });

                    setTimeout(() => {
                        setEmailSmsSendView(false);
                        setSmsVerificationView(true);
                        setNewPasswordView(false);
                    }, 600);
                }
                else if (response.data.Status == 'Error') {
                    if (response.data.Error?.includes("0x999999")) {
                        toast.current.show({ severity: "error", summary: "SMS gönderilemedi.", detail: " Email adresi yanlış veya böyle bir kullanıcı bulunmamakta." });
                    }
                    else if (response.data.Error?.includes("0xCD5C5C")) {
                        toast.current.show({ severity: "error", summary: "SMS gönderilemedi.", detail: " Kullanıcıya ait telefon numarası bulunamadı." });
                    }
                    else if (response.data.Error?.includes("0x3783B6")) {
                        toast.current.show({ severity: "error", summary: "SMS gönderilemedi.", detail: " Database üzerinde telefon formatı yanlış." });
                    }
                    else if (response.data.Error?.includes("0x5A2K1A")) {
                        toast.current.show({ severity: "error", summary: "SMS gönderilemedi.", detail: " Bir hata oluştu. Tekrar deneyiniz." });
                    }
                } else {
                    toast.current.show({
                        severity: "error",
                        summary: "Hata",
                        detail: "Bir hata oluştu. " + response.data.Error,
                        life: 4000,
                    });
                }

            }).catch((error) => {
                // console.log("beginLogin: " + error);
                // toast.current.show({
                //     severity: "error",
                //     summary: "Hata",
                //     detail: "Bir hata oluştu.",
                //     life: 3000,
                // });
                console.log("clickResetPassword: " + error);
            });
            // console.log("clickResetPassword");
        } catch (error) {
            // console.log("clickResetPassword: " + error);
        }
    };


    const beginLogin = () => {
        try {
            contextVal.setAuthState({
                ...contextVal?.authState,
                loginView: true,
                verificationView: false,
                passwordResetView: false,
            });

        } catch (error) {
            // console.log("verificationHandle: " + error);
        }
    };

    const validateEmail = (email) => {
        // Basit bir düzenli ifade kullanarak e-posta adresini kontrol etme
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const smsVerified = (data) => {
        
        if (data.smsVerified) {
            setfFingerPrint(data.fingerPrint);
        }
        else {
            setSmsVerificationView(true);
            setNewPasswordView(false);
        }
    }


    return (
        <>
            <Toast ref={toast} position="bottom-right" />
            <Col md="12">

                {emailSmsSendView && (
                    <>

                        <Container className="verification">
                            <Row className="verification-row">
                                <Col md="12">
                                    <div className="col-md-12 roboto-bold-34 color-text">Şifrenizi Sıfırlayın</div>
                                </Col>
                                <Col md="12" className="input-col m-t-20">
                                    <InputText type="email" className="verification-input" placeholder="E Posta Adresi" value={userMail} onChange={(e) => setUserMail(e.target.value)} />
                                    <Button slot="end" className="loginBtn m-t-60" onClick={clickResetPassword}>
                                        GÖNDER
                                    </Button>
                                    <label className="color-text-grey roboto-medium-14 m-t-15" onClick={beginLogin}>
                                        Şifrenizi hatırladınız mı? <span className="login-now-text">Giriş yap.</span>{" "}
                                    </label>
                                </Col>
                            </Row>
                        </Container>
                    </>
                )}

                {smsVerificationView && (
                    <SmsVerificationResetPassword email={userMail} smsVerified={smsVerified} />
                )}

                {newPasswordView && (
                    <NewPassword email={userMail} fingerPrint={fingerPrint} />
                )}

            </Col>






        </>
    );
}
